export const applyTwitterWidgetStyles = () => {
  const twitterIframes = document.querySelectorAll(
    'iframe[id^="twitter-widget"]',
  );

  twitterIframes.forEach((iframe: any) => {
    if (iframe) {
      iframe.style.maxWidth = '100%';
      iframe.style.width = '100%';
      iframe.style.display = 'block';
    }
  });
};

const normalizeTwitterStatusUrl = (rawUrl: string) => {
  if (!rawUrl) return '';
  try {
    const url = new URL(rawUrl, window.location.origin);
    if (!/(^|\.)x\.com$|(^|\.)twitter\.com$/.test(url.hostname)) {
      return '';
    }
    const match = url.pathname.match(/^\/([^/]+)\/status\/(\d+)/);
    if (!match) return '';
    return `https://twitter.com/${match[1]}/status/${match[2]}`;
  } catch {
    return '';
  }
};

export const normalizeTwitterEmbedsForStorage = (html: string) => {
  if (!html || typeof window === 'undefined') return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // widgets.js 삽입 흔적 제거
  doc
    .querySelectorAll('script[src*="platform.twitter.com/widgets.js"]')
    .forEach((script) => script.remove());

  doc.querySelectorAll('.x-embed').forEach((embedNode) => {
    const embed = embedNode as HTMLElement;
    const attrUrl = embed.getAttribute('data-url') || '';
    const linkUrl =
      (embed.querySelector('a[href]') as HTMLAnchorElement | null)?.href || '';
    const iframeUrl =
      (embed.querySelector('iframe[src]') as HTMLIFrameElement | null)?.src || '';
    const normalizedUrl = normalizeTwitterStatusUrl(attrUrl || linkUrl || iframeUrl);

    if (!normalizedUrl) return;

    embed.classList.add('x-embed');
    embed.setAttribute('contenteditable', 'false');
    embed.setAttribute('data-url', normalizedUrl);
    embed.innerHTML = '';

    const blockquote = doc.createElement('blockquote');
    blockquote.className = 'twitter-tweet';
    const anchor = doc.createElement('a');
    anchor.href = normalizedUrl;
    anchor.textContent = normalizedUrl;
    blockquote.appendChild(anchor);
    embed.appendChild(blockquote);
  });

  // 기존에 렌더된 twitter blockquote/iframe 흔적 정리
  doc.querySelectorAll('.twitter-tweet-rendered').forEach((node) => {
    node.classList.remove('twitter-tweet-rendered');
  });
  doc.querySelectorAll('iframe[id^="twitter-widget"]').forEach((iframe) => {
    iframe.remove();
  });

  // <head> 안의 <style>/<link> 태그는 DOMParser가 doc.head로 이동시킨다.
  // doc.body.innerHTML만 반환하면 이 태그들이 유실되므로, head에서 추출해 앞에 붙인다.
  const headElements = Array.from(doc.head.children)
    .filter((el) => el.tagName === 'STYLE' || el.tagName === 'LINK')
    .map((el) => el.outerHTML)
    .join('');

  return headElements + doc.body.innerHTML;
};

export function loadTwitterWidget(targetRoot?: HTMLElement | null) {
  const scriptSrc = 'https://platform.twitter.com/widgets.js';

  const runWidget = () => {
    // 트윗 blockquote 중 가장 마지막 걸 대상으로 위젯 로딩
    const block = targetRoot?.querySelectorAll('.twitter-tweet');
    const latest = block?.[block.length - 1];

    if (latest && window.twttr?.widgets?.load) {
      setTimeout(() => {
        window.twttr.widgets.load(latest);
        setTimeout(applyTwitterWidgetStyles, 500);
      }, 100); // DOM이 완전히 반영된 뒤 로딩
    }
  };

  if (window.twttr) {
    runWidget();
  } else {
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      script.onload = runWidget;
      document.body.appendChild(script);
    } else {
      const interval = setInterval(() => {
        if (window.twttr?.widgets?.load) {
          runWidget();
          clearInterval(interval);
        }
      }, 200);
    }
  }
}

export function loadTwitterWidgetsSafe(callback?: () => void) {
  const tryLoad = () => {
    if ((window as any).twttr?.widgets?.load) {
      (window as any).twttr.widgets.load();

      // 위젯 로드 후 iframe 스타일 강제 적용
      setTimeout(() => {
        applyTwitterWidgetStyles();
      }, 500);

      if (callback) callback();
    } else {
      // 아직 안 로드됐으면 200ms 뒤 다시 시도
      setTimeout(tryLoad, 200);
    }
  };
  tryLoad();
}
